<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper" >
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="供应商名称" prop="supplierName">
                  <a-input v-model="queryParam.supplierName" :maxLength="16" :placeholder="$t('请输入')+'供应商名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="  8 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :customRow="loadCustomRow"
          :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'checkbox',  onChange: onSelectChange}"
          :pagination="false"
          :bordered="tableBordered"
        >
        </a-table>
    </a-card>
  </a-modal>
</template>

<script>
import {listSupplier} from '@/api/supplier/supplier'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {tableMixin} from '@/store/table-mixin'


export default {
  name: 'RadioSupplierSelectForm',
  props: {},
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      limitNum: undefined,
      selectedRowKeys: [],
      id: undefined,
      selectedRows: [],
      categoryList: [],
      cateOptions: [],
      brandList: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      idText:null,
      // 查询参数
      queryParam: {
        supplierName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '供应商编号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
      ]
    };
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    selectGoodsAll() {
      //查询该条件下所有的商品,
      listSelectGoods(this.queryParam).then(response => {
        this.selectedRows = response.data;
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
        this.onOk()
      })

      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param id

     */
    openGoods(supplierId,id) {
      if (supplierId) {
        console.log('带过来的key',supplierId)
        this.selectedRowKeys = [supplierId]
        this.queryParam.orderByGoodsIdList = [supplierId];
      }
      this.id = id
      this.getList();
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('supplierSelect', this.selectedRowKeys[0],this.id)
      this.resetQueryForm()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQueryForm()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      listSupplier(this.queryParam).then(response => {
        this.list = response.data
        this.total = response.data.length
        this.loading = false
      })
    },
    resetQueryForm() {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        supplierName: null,
        pageNum: 1,
        pageSize: 10
      }
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        if (this.limitNum) {
          if (this.selectedRows.length >= this.limitNum) {
            console.log('到达了限制数量,',this.limitNum)
            return false
          }
        }
        this.selectedRows.push(record)
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows =this.selectedRows.concat(changeRows)
      } else {
        let selectIds = changeRows.map(e => e.id);
        this.selectedRows = this.selectedRows.filter(e => !selectIds.includes(e.id));
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRowKeys.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          },
          dblclick: () => {
            this.onOk()
          },
        }
      }
    },
  }
}
</script>
